// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedShift: null
}

const shifts = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_SHIFTS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_SHIFTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_SHIFT':
      return { ...state, selectedShift: action.selectedShift }
    case 'ADD_SHIFT':
      return { ...state }
    case 'DELETE_SHIFT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default shifts
